import { Button, Divider } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import React, { useContext } from "react";
import { AppContext, TOGGLE_TERMS } from "../../context";

const useStyles = createStyles(() => ({
  outerWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "2rem 1rem",
  },
  innerWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  header: {
    margin: "0",
    textAlign: "center",
  },
  subHeader: {
    margin: "2rem",
    fontWeight: "normal",
  },
  infoWrapper: {
    backgroundColor: "rgb(245, 245, 245)",
    padding: "2rem",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  infoHeader: {
    alignSelf: "start",
    marginBottom: "1rem",
  },
  listWrapper: {
    listStyle: "none",
    padding: "0",
    width: "100%",

    "& li": {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "0.25rem",

      "& span:nth-of-type(2)": {
        fontWeight: "600",
      },
    },
  },
  buttonWrapper: {
    width: "100%",
    marginTop: "1rem",
  },
}));

const SubscriptionInfo = ({ data, language }) => {
  const { classes } = useStyles();
  const { dispatch } = useContext(AppContext);

  const { subscriptionArticle } = data.subscriptionById;
  const subscription = data.subscriptionById;
  const termType =
    subscription.termType === "FixedTerm"
      ? `${language.Subscription_TermType_Fixed}, ${subscription.fixedTermNumberOfPeriods} ${language.Subscription_Payments}`
      : `${language.Subscription_TermType_Ongoing}`;
  const customerName = `${subscription.firstname} ${subscription.lastname}`;

  return (
    <div className={classes.outerWrapper}>
      <main id="main-page-content" className={classes.innerWrapper}>
        <h1 className={classes.header}>{language.Subscription_Header}</h1>
        <p className={classes.subHeader}>{language.Subscription_SubHeader}</p>
        <div className={classes.infoWrapper}>
          <h2 className={classes.infoHeader}>{language.Cart}</h2>
          <ul className={classes.listWrapper}>
            <li>
              <span>{language.Customer}</span>
              <span>{customerName}</span>
            </li>
            <li>
              <span>{language.Subscription_ArticleName}</span>
              <span>{subscriptionArticle.name}</span>
            </li>
            <li>
              <span>{language.Subscription_Name}</span>
              <span>{subscription.subscriptionTypeName}</span>
            </li>
            <li>
              <span>{language.Subscription_TermType}</span>
              <span>{termType}</span>
            </li>
            <li>
              <span>{language.Subscription_PricePerMonth}</span>
              <span>{subscriptionArticle.priceInclVat}</span>
            </li>
          </ul>
          <Divider
            my="lg"
            style={{ borderTopColor: "#E7E9EC", width: "100%" }}
          />
          <p>{language.Subscription_ParagraphInfo}</p>
          <div className={classes.buttonWrapper}>
            <Button
              color="primary"
              onClick={() => {
                dispatch({ type: TOGGLE_TERMS });
              }}
              className={`${classes.paymentButton} primaryButton`}
              id="toPaymentButton"
              fullWidth
              size="md"
            >
              {language.Go_To_Payment}
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SubscriptionInfo;
